<template>
  <div class="form-wrapper">
    <form id="mktoForm_2489"></form>
    <div class="ty-block" id="mktoForm_2489-ty-block">
      <h4>Thanks! We can't wait to connect with you.</h4>
      <p>One of our representatives will be in touch shortly.</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EmailForm',
  data() {
    return {
      formId: 'mktoForm_2489',
    }
  },
  methods: {
    // listenForSubmit() {
    //   const form = document.getElementById(this.formId);

    //   form.addEventListener("submit", () => {
    //     // var inputs = document.querySelectorAll('input[type="text"]');
    //     var valid = true;
    //     // inputs.forEach(function(item) {
    //     //   if (item.value == null || item.value == '') {
    //     //     valid = false;
    //     //   } else if (item.getAttribute('type') === 'email' && !item.value.includes('@')) {
    //     //     valid = false;
    //     //   }
    //     // })

    //     if (valid) {
          
    //     }
    //   })
    // },
    handleSuccess(form) {
      form.onSuccess(() => {
        // Hide the form
        form.getFormElem().hide();
        
        // Show a thank you 
        document.getElementById("mktoForm_2489").style.display = "none";
        document.getElementById("mktoForm_2489-ty-block").style.display = "block"

        window.dataLayer = window.dataLayer || [];
        const email = document.getElementById('Email').value;
        const firstName = document.getElementById('FirstName').value;
        const lastName = document.getElementById('LastName').value;
        const country = document.getElementById('Country').value;
        
        window.dataLayer.push({
          'event': 'builder_email_submitted',
          'solutionBuilderName': 'Solution Configurator',
          'email': email,
          'company': 'N/A',
          'firstName': firstName,
          'lastName': lastName,
          'country': country,
          'userAnswers': JSON.stringify(this.$store.state.userAnswers).replaceAll('"', "'").replaceAll(/[\\{}]/g, ""),
          'campaignId': '7012J000001lB8qQAE',
          'campaignName': '21_IT_Website_Demand-Vol-Website_CSHub_Solution Builder',
          'q1_challenges': this.get('challenges'),
          'q2_industry': this.get('industry'),
          'q3_size': this.get('size'),
          'q4_maturity': this.get('maturity'),
          'q5_role': this.get('role'),
          'q6_integrations': this.get('integrations'),
          'q7_priorities': this.get('priorities'),
          'q8_timeframe': this.get('timeframe'),
          'q9_approach': this.get('approach'),
        })

        console.log({
          'event': 'builder_email_submitted',
          'solutionBuilderName': 'Solution Configurator',
          'email': email,
          'company': 'N/A',
          'firstName': firstName,
          'lastName': lastName,
          'country': country,
          'userAnswers': JSON.stringify(this.$store.state.userAnswers).replaceAll('"', "'").replaceAll(/[\\{}]/g, ""),
          'campaignId': '7012J000001lB8qQAE',
          'campaignName': '21_IT_Website_Demand-Vol-Website_CSHub_Solution Builder',
          'q1_challenges': this.get('challenges'),
          'q2_industry': this.get('industry'),
          'q3_size': this.get('size'),
          'q4_maturity': this.get('maturity'),
          'q5_role': this.get('role'),
          'q6_integrations': this.get('integrations'),
          'q7_priorities': this.get('priorities'),
          'q8_timeframe': this.get('timeframe'),
          'q9_approach': this.get('approach'),
        })

        // Return false to prevent the submission handler continuing with its own processing
        return false;
      });
    }
  },
  computed: {
    ...mapGetters([
      'get',
    ]),
  },
  mounted() {
    let marketoInitialised = false;
    let retryCount = 50;

    const initialise_forms = () => {
      if (!marketoInitialised && retryCount--) {
        // Make sure Marketo script is available
        // eslint-disable-next-line
        if (typeof MktoForms2 !== "undefined") {
          // eslint-disable-next-line
          MktoForms2.loadForm(
            "//landing.hyland.com",
            "310-IWJ-963",
            "2489",
            this.handleSuccess
          );

          console.log("Forms initialised");
          marketoInitialised = true;
        } else {
          console.log("Forms not ready, try again...");
          setTimeout(initialise_forms, 100);
        }
      }
    };

    initialise_forms();

    // this.listenForSubmit();
  }
}
</script>

<style>
  .mktoForm {
    width: auto !important;
    display: block !important;
  }

  .form-wrapper {
    max-width: 60%;
    margin: 0 auto;
    border-radius: 16px;
    background-color: #f1efef;
    padding: 1.5rem;
    margin-top: 24px;
  }

  @media (max-width: 768px) {
  .form-wrapper {
      max-width: 100%;
    }
  }

  .mktoForm .mktoFormRow .mktoFieldWrap input[type],
  .mktoForm .mktoFormRow .mktoFieldWrap textarea,
  .mktoForm .mktoFormRow .mktoFieldWrap select {
    max-width: 100% !important;
    min-width: 100% !important;
    width: 100% !important;
  }

  .ty-block {
    display: none;
  }
</style>